<template>
    <ul class="w-full text-sm p-1">
      <span v-for="item in items" :key="item.menuId">
        <base-aside-nav-item :key="item.menuId" :item="item" :role="role" v-bind="$attrs"  />
      </span>
    </ul>
</template>

<script>

export default {
  name: 'aside-nav',
  props: {
    items: {
      type: [Array, Object],
      required: true
    }
  },
  data: function () {
    return {

    }
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    }
  }
}
</script>

<style lang="scss" scoped></style>
